module.exports = __webpack_public_path__ + "static/sport/bg.4aec1d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/football/pc/bg.jpg
// module id = AL1a
// module chunks = 0